{
    "webshop_offer_voucher_correctCode": "Código correcto",
    "webShop_howToFindId_desc": "Puedes buscar y copiar tu ID personal en el perfil.",
    "webShop_howToFindId_link": "¿Dónde puedo ver mi ID personal?",
    "webshop_offer_voucher_codeIsIncorrect": "Código incorrecto",
    "webshop_offer_voucher_enterYourCode": "Escribe tu ID personal...",
    "webShop_unexpectedError_desc": "Se ha producido un error inesperado. Inténtalo de nuevo más tarde.",
    "webShop_accountBanned_desc": "¡Cuenta bloqueada!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Condiciones de uso",
    "webshop_purchase_privacyPolicy": "Política de privacidad",
    "webshop_legal_1": "Legal",
    "webshop_support_1": "Asistencia",
    "mbs_access_welcome_desc": "¡Hola, {0}!",
    "btn_login": "Iniciar sesión",
    "mbs_access_error_sessionExpired_desc": "La sesión ha caducado. Introduce tu ID de cuenta de forma manual."
}
